export default class Palette {

    static IIDEC_RED = "#f05d29"
    static IIDEC_LIGHT_PALE_RED = "#f37e55"

}
